module.exports = __webpack_public_path__ + "img/music_012.eddfc5e1.png";